import React from 'react';

interface RejectModalProps {
    isOpen: boolean;
    onClose: () => void;
    onReject: () => void;
    templeName: string;
    reason: string;
    setReason: (reason: string) => void;
    loading: boolean;
}

export const RejectModal: React.FC<RejectModalProps> = ({
    isOpen,
    onClose,
    onReject,
    templeName,
    reason,
    setReason,
    loading
}) => {
    if (!isOpen) return null;

    return (
        <div className="modal-overlay" onClick={onClose}>
            <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                <div className="modal-header">
                    <h3>Reject Temple Registration</h3>
                    <button className="modal-close" onClick={onClose}>×</button>
                </div>
                <div className="modal-body">
                    <p className="text-gray-600 mb-4">
                        Please provide a reason for rejecting the registration of <strong>{templeName}</strong>.
                    </p>
                    <div className="form-group">
                        <label>Rejection Reason *</label>
                        <textarea
                            value={reason}
                            onChange={(e) => setReason(e.target.value)}
                            className="form-textarea"
                            rows={4}
                            placeholder="Please explain why this registration is being rejected..."
                            required
                        />
                    </div>
                </div>
                <div className="modal-actions">
                    <button onClick={onClose} className="btn-secondary">
                        Cancel
                    </button>
                    <button
                        onClick={onReject}
                        className="btn-danger"
                        disabled={loading || !reason.trim()}
                    >
                        {loading ? 'Rejecting...' : 'Reject Registration'}
                    </button>
                </div>
            </div>
        </div>
    );
};

interface SubscriptionModalProps {
    isOpen: boolean;
    onClose: () => void;
    onAssign: () => void;
    plans: any[];
    selectedPlanId: string;
    setSelectedPlanId: (id: string) => void;
    loading: boolean;
    error: string | null;
}

export const SubscriptionModal: React.FC<SubscriptionModalProps> = ({
    isOpen,
    onClose,
    onAssign,
    plans,
    selectedPlanId,
    setSelectedPlanId,
    loading,
    error
}) => {
    if (!isOpen) return null;

    return (
        <div className="modal-overlay" onClick={onClose}>
            <div className="modal-content" onClick={(e) => e.stopPropagation()} style={{ maxWidth: '600px' }}>
                <div className="modal-header">
                    <h3>Assign Subscription Plan</h3>
                    <button className="modal-close" onClick={onClose}>×</button>
                </div>
                <div className="modal-body">
                    <div className="form-group">
                        <label>Select Subscription Plan *</label>
                        <select
                            className="form-select"
                            value={selectedPlanId}
                            onChange={(e) => setSelectedPlanId(e.target.value)}
                            required
                        >
                            <option value="">-- Select a plan --</option>
                            {plans
                                .filter(plan => plan.isActive)
                                .map(plan => (
                                    <option key={plan._id} value={plan._id}>
                                        {plan.name} - ${plan.price} {plan.currency} / {plan.billingCycle}
                                    </option>
                                ))}
                        </select>
                    </div>
                    {error && (
                        <div className="error-message" style={{ marginTop: '1rem', padding: '0.75rem', backgroundColor: '#fee', color: '#c33', borderRadius: '4px' }}>
                            {error}
                        </div>
                    )}
                </div>
                <div className="modal-actions">
                    <button onClick={onClose} className="btn-secondary">
                        Cancel
                    </button>
                    <button
                        onClick={onAssign}
                        className="btn-primary"
                        disabled={loading || !selectedPlanId}
                    >
                        {loading ? 'Assigning...' : 'Assign Plan'}
                    </button>
                </div>
            </div>
        </div>
    );
};
